export const BOOTSTRAP_COMPLETE = 'BOOTSTRAP_COMPLETE';

export const BOOTSTRAP_STARTED = 'BOOTSTRAP_STARTED';
